export const ModalPopup = {
  bindings: {
    size: '@',
    isLoading: '<',
  },

  transclude: {
    body: '?modalBody',
  },

  template: `
    <div class="modal modal-popup"
      data-show="true"
      data-keyboard="false"
      data-backdrop="false"
      tabindex="-1"
      role="dialog"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-{{ $ctrl.size || 'md' }}" role="document">
        <div class="modal-content">
          <div class="modal-body" ng-transclude="body"></div>
          <button
            class="close border-top font-weight-normal text-green-dark p-3"
            type="button"
            data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">Close</span>
          </button>
        </div>
      </div>
    </div>`,

  controller($element) {
    'ngInject';

    return {
      $onInit() {
        const $el = $element.find('.modal');

        // Display the modal
        $el.modal();
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Modal/Popup.js